import React, {useState} from 'react';
import CreateSingleDataset from "./create-single-dataset/CreateSingleDataset";
import {RadioButton} from "primereact/radiobutton";
import CreateMultipleDatasets from "./create-multiple-datasets/CreateMultipleDatasets";

export const DATASET_DATA_TYPES = [
    {
        label: 'Hourly',
        value: 'HOURLY',
    },
    {
        label: 'Daily',
        value: 'DAILY',
    },
    {
        label: 'Arbitrary',
        value: 'ARBITRARY',
    },
    {
        label: 'Monthly',
        value: 'MONTHLY',
    },
    {
        label: 'Weekly',
        value: 'WEEKLY',
    },
    {
        label: 'Seconds',
        value: 'SECONDS',
    },
    {
        label: 'Minutes',
        value: 'MINUTES',
    },
    {
        label: 'Arbitrary (minutes)',
        value: 'ARBITRARY_MINUTES',
    },
    {
        label: 'Arbitrary (seconds)',
        value: 'ARBITRARY_SECONDS',
    },
];

export const DATASET_ACCESS_TYPES = [
    {
        label: 'Normal',
        value: 'NORMAL',
    },
    {
        label: 'Continuous',
        value: 'CONTINUOUS',
    },
    {
        label: 'Data Model Day',
        value: 'DATA_MODEL_DAY',
    },
];

export const DATASET_DEFAULT_DIALOG_STATE = {
    unitSelectorValue: '',
    datasetTitle: '',
    dataType: 'ARBITRARY',
    accessType: 'NORMAL',
    defaultCategory: undefined,
};

const CreateDatasetDialog = ({setCreateDialogVisibility}) => {
    const [datasetCreationType, setDatasetCreationType] = useState('SINGLE');

    return (
        <div className="flex flex-column">
            <div className="flex mb-2">
                <div className="flex gap-1 align-items-center">
                    <RadioButton inputId="single" name="datasetCreationType" value="SINGLE"
                                 onChange={(e) => setDatasetCreationType(e.value)}
                                 checked={datasetCreationType === "SINGLE"}/>
                    <label htmlFor="single" className="p-radiobutton-label mr-2">Single</label>
                </div>
                <div className="flex gap-1 align-items-center">
                    <RadioButton inputId="multiple" name="datasetCreationType" value="MULTIPLE"
                                 onChange={(e) => setDatasetCreationType(e.value)}
                                 checked={datasetCreationType === "MULTIPLE"}/>
                    <label htmlFor="multiple" className="p-radiobutton-label">Multiple</label>
                </div>
            </div>

            {datasetCreationType === "SINGLE" &&
                <CreateSingleDataset setCreateDialogVisibility={setCreateDialogVisibility}/>}
            {datasetCreationType === "MULTIPLE" &&
                <CreateMultipleDatasets setCreateDialogVisibility={setCreateDialogVisibility}/>}
        </div>

    )
};

export default CreateDatasetDialog;
